import { render, staticRenderFns } from "./CardTraceability.vue?vue&type=template&id=54f18b9b&scoped=true"
import script from "./CardTraceability.vue?vue&type=script&lang=js"
export * from "./CardTraceability.vue?vue&type=script&lang=js"
import style0 from "./CardTraceability.vue?vue&type=style&index=0&id=54f18b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f18b9b",
  null
  
)

export default component.exports